import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { pickCss } from '@/shared/lib/css-utils';
import css from './markdown.module.scss';

const rootCss = pickCss(css, css.root);

export type MarkdownProps = {
  // Raw markdown string (e.g. an LLM answer). Rendered to safe HTML —
  // react-markdown does NOT render embedded raw HTML by default, so untrusted
  // model output can't inject markup.
  children: string;
  className?: string;
};

// Renders a markdown string as formatted, theme-styled content. GFM enabled
// (tables, task lists, strikethrough, autolinks). Element styling lives in the
// scoped `.root` block in the SCSS module.
export const Markdown = ({ children, className }: MarkdownProps) => (
  <div className={rootCss({}, className)}>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
  </div>
);
